import { Box, Container } from "@mui/material";

const ForgotPass = () => {
  return (
    <Container className="container-xxl py-12 pt-sm-20 pb-sm-32">
      <Box className="col-sm-10 col-md-7 col-lg-5 col-xl-4 card mx-auto p-6">
        <Box className="text-center mb-5">
          <Box className="h4">Password Recovery</Box>
          <Box className="text-muted mb-0 text-center">
            Enter the email address you used when you joined and we'll send you
            instructions to reset your password.
          </Box>
        </Box>

        <Box className="js-form-message form-group mb-4">
          <input
            name="ctl00$ContentPlaceHolder1$txtUserName"
            type="text"
            id="ContentPlaceHolder1_txtUserName"
            className="form-control form-control-lg py-3"
            placeholder="Your email address"
          />
        </Box>

        <input
          type="submit"
          name="ctl00$ContentPlaceHolder1$btnLogin"
          value="LOGIN"
          id="ContentPlaceHolder1_btnLogin"
          className="btn btn-lg btn-primary w-100 py-3 mt-2"
        />
      </Box>
    </Container>
  );
};

export default ForgotPass;
